import { useState } from "react";
import { X } from "lucide-react";
import { Badge } from "./ui/badge";
import { getPhotoUrl } from "../lib/api";

export function PhotoGrid({ photos, spotTitle, onDelete }) {
  const [lightboxPhoto, setLightboxPhoto] = useState(null);

  if (!photos || photos.length === 0) {
    return null;
  }

  const photoItems = [];
  for (let i = 0; i < photos.length; i++) {
    const photo = photos[i];
    photoItems.push(
      <div key={photo} className="relative group rounded-lg overflow-hidden aspect-square bg-slate-100">
        <img src={getPhotoUrl(photo)} alt={spotTitle + " " + (i + 1)} className="w-full h-full object-cover cursor-pointer" onClick={() => setLightboxPhoto(photo)} />
        {onDelete && (
          <button
            onClick={() => onDelete(photo)}
            className="absolute top-1 right-1 bg-red-500 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <X className="w-3 h-3" />
          </button>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="grid grid-cols-2 gap-2">{photoItems}</div>
      {lightboxPhoto && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center"
          onClick={() => setLightboxPhoto(null)}
        >
          <button
            className="absolute top-4 right-4 text-white bg-white/10 rounded-full p-2"
            onClick={() => setLightboxPhoto(null)}
          >
            <X className="w-5 h-5" />
          </button>
          <div
            className="w-full h-full overflow-auto flex items-center justify-center"
            style={{ touchAction: "pinch-zoom" }}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={getPhotoUrl(lightboxPhoto)}
              alt={spotTitle}
              className="max-w-none"
              style={{ maxHeight: "90vh", maxWidth: "90vw" }}
            />
          </div>
        </div>
      )}
    </>
  );
}

export function TagList({ tags }) {
  if (!tags || tags.length === 0) return null;

  const tagItems = [];
  for (let i = 0; i < tags.length; i++) {
    tagItems.push(
      <Badge key={tags[i]} variant="secondary" className="text-xs">{tags[i]}</Badge>
    );
  }

  return <div className="flex flex-wrap gap-1">{tagItems}</div>;
}
